import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { useDispatch } from "react-redux";

import HeaderDrawer from "../HeadbarDrawer/component";

import "./HeaderStyles.scss";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { clearError } from "../../slices/Employee/editEmployeeProfile.slice";
import HeaderMenu from "./HeaderMenu";

export default function Header() {
  const { Header } = Layout;
  const dispatch = useDispatch();
  const [drawerVisible, setVisible] = useState(false);
  const [editProfileDrawer, setEditProfileDrawer] = useState(false);
  const [changePasswordDrawer, setChangePasswordDrawer] = useState(false);

  const location = useLocation();

  const isPreAssessmentScreen = location.pathname === "/pre-assessments";

  useEffect(() => {
    dispatch(clearError());
  }, [drawerVisible]);

  const showDrawer = (drawerType) => {
    setVisible(true);
    if (drawerType === "Edit Profile") {
      setEditProfileDrawer(true);
      setChangePasswordDrawer(false);
    } else {
      setEditProfileDrawer(false);
      setChangePasswordDrawer(true);
    }
  };

  const handleChangePasswordOnClick = () => {
    setEditProfileDrawer(false);
    setChangePasswordDrawer(true);
  };

  return (
    <>
      <Header
        className={`${
          isPreAssessmentScreen ? "pre-assessment-header" : ""
        } header`}
        style={{
          position: "fixed",
          zIndex: 100,
          width: "100%",
          height: "72px",
          padding: "0 0 0 1.25%",
          lineHeight: "72px",
        }}
      >
        <HeaderMenu
          showDrawer={showDrawer}
          isPreAssessmentScreen={isPreAssessmentScreen}
        />
      </Header>
      <HeaderDrawer
        drawerVisible={drawerVisible}
        onClose={() => setVisible(false)}
        editProfileDrawer={editProfileDrawer}
        changePasswordDrawer={changePasswordDrawer}
        setEditProfileDrawer={setEditProfileDrawer}
        handleChangePasswordOnClick={handleChangePasswordOnClick}
      />
    </>
  );
}
